import { z } from 'zod';
const CODE = /^[A-Z]{2}$/;
const FIRST = 'A'.charCodeAt(0);
const LETTERS = 26;
/** CLDR's "unknown region". */
const UNKNOWN_REGION = 'ZZ';
const regionNames = new Intl.DisplayNames(['en'], { type: 'region', fallback: 'none' });
/** Whether the runtime knows this ISO 3166-1 alpha-2 code (e.g. `JP`, `CN`, `TW`, `HK`). */
export function isCountryCode(code) {
    return CODE.test(code) && code !== UNKNOWN_REGION && regionNames.of(code) !== undefined;
}
let codes;
/** Every region code the runtime knows, for pickers (labels come from `Intl.DisplayNames`). */
export function countryCodes() {
    codes ??= Array.from({ length: LETTERS * LETTERS }, (_, index) => String.fromCharCode(FIRST + Math.floor(index / LETTERS), FIRST + (index % LETTERS))).filter(isCountryCode);
    return codes;
}
export const zCountryCode = z
    .string()
    .trim()
    .toUpperCase()
    .refine(isCountryCode, { message: 'Unknown ISO 3166-1 country code' });
//# sourceMappingURL=country.js.map